import { useState, useEffect } from 'react'
import { productsApi, Product } from '../services/api'

export const useProducts = (collection?: 'boys' | 'girls' | 'all') => {
  const [products, setProducts] = useState<Product[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setIsLoading(true)
        setError(null)

        const response = await productsApi.getAll()

        if (response.success && response.data) {
          setProducts(response.data)
        } else if (Array.isArray(response.data)) {
          setProducts(response.data)
        } else {
          setProducts([])
        }
      } catch (err) {
        console.error('Error al cargar productos:', err)
        setError('Error al cargar productos')
        setProducts([])
      } finally {
        setIsLoading(false)
      }
    }

    loadProducts()
  }, [])

  // Filtrar por colección en el frontend
  const filteredProducts = collection
    ? products.filter(p => p.collection === collection || p.collection === 'all')
    : products

  return { products: filteredProducts, isLoading, error }
}
